import { PublicAuthToken, ScopeDefinition } from '@api/types/PublicAuthToken';
import { deleteAllPublicAuthTokens, findPublicAuthToken, getPublicAuthToken } from '@features/authentication/storageFunctions';
import { AppAuthMode } from '@features/authentication/types/AppAuthMode';
import { User } from '@project-types/User';
import { plainSetAppAuthMode } from '@features/authentication/store/slice';
import { plainSelectUser } from '@features/authentication/store/selectors';



export const handleLogout = () => {
	deleteAllPublicAuthTokens();
};



export const isAuthenticated = (): boolean => {
	const userFromStore = plainSelectUser();
	if (userFromStore) return true;

	let token = findPublicAuthToken();
	if (token) return true;

	return false;
};



export const getUser = (): User | null => {
	const userFromStore = plainSelectUser();
	if (userFromStore) return userFromStore;

	let authToken = findPublicAuthToken();
	if (!authToken) return null;

	
	let appScope = getAppScope(authToken);
	if (!appScope) return null;
	
	return ({
		userId: authToken.userId,
		userName: authToken.userName,
		roles: appScope.roles,
		secureAttributes: appScope.secureAttributes,
		customFields: appScope.customFields,
	});
};



export const getUserName = (): string => {
	const user = getUser();
	return user ? user.userName : '-';
};



export const getBearerToken = (): string => {
	const userFromStore = plainSelectUser();
	
	if (userFromStore) {
		const authToken = getPublicAuthToken(userFromStore.userId);
		
		if (authToken) {
			return authToken.token;
		}
	}

	let findedAuthToken = findPublicAuthToken();
	if (findedAuthToken) {
		return findedAuthToken.token;
	}

	console.error('Authentication Error: Cannot get auth token');
	console.error(`Details:\nEnvironment: ${process.env.ENV}\nUser: ${userFromStore ? userFromStore.userId : '-'}`);
	plainSetAppAuthMode(AppAuthMode.authFailed);
	return '-default-';
};


export const getAppScope = (publicAuthToken: PublicAuthToken | null | undefined): ScopeDefinition | null => {
	try {
		if (!publicAuthToken || !publicAuthToken.scope) return null;

		const appScope = publicAuthToken.scope.find(x => x.app === process.env.AUTH_APP);
		if (appScope) return appScope;

		console.error('Authentication Error: Cannot get Scope for this app');
		console.error(`Details:\nApp: ${process.env.AUTH_APP}\nToken Scopes: ${publicAuthToken.scope.map(x => x.app).join()}`);
		return null;
	}
	catch (error) {
		console.error('Authentication Error: Failed to get app scope');
		console.error(`Details:\nError: ${error}\nEnvironment: ${process.env.ENV}`);
		return null;
	}
};